// extracted by mini-css-extract-plugin
export default {"subtitle__text":"SubtitleText_subtitle__text__xv26U"};